import React, { useState, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import { useAuthUser } from "react-auth-kit"
import { Link } from "react-router-dom"

function CancelOrder({ isOpen, onClick, onClose, id }) {
	const auth = useAuthUser()
	const user = auth()
	const [isMounted, setIsMounted] = useState(false)
	const [error, setError] = useState(null)
	const [reasons, setReasons] = useState([])
	const [reason, setReason] = useState([])
	const [isSuccess, setIsSuccess] = useState(false)
	const [loading, setLoading] = useState(false)
	const reasonInputRef = useRef(null)

	const handleClose = () => {
		onClose()
		setError(null)
		setLoading(false)
	}

	const handleReason = (e) => {
		setReason()
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		if (reason === "Select a reason") {
			setError("Please select a reason for cancellation.")
			setLoading(false)
			return
		} else {
			try {
				const response = await fetch(
					`https://api.baobabcircle.com/pharmacy/orders/${id}/cancel`,
					{
						method: "POST",
						headers: {
							Authorization: `Bearer ${user.apikey}`,
							// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							cancellationReason: reason,
						}),
					}
				)
				const result = await response.json()
				if (result.error) {
					setError(result.error)
					setLoading(false)
					setIsSuccess(false)
					return
				}
				setIsSuccess(true)
			} catch (error) {
				setError(error.message)
				setLoading(false)
				console.log(error)
			} finally {
				setLoading(false)
			}
		}
	}

	useEffect(() => {
		fetch(
			"https://api.baobabcircle.com/pharmacy/orders/cancellation-reasons",
			{
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					authorization: `Bearer ${user.apikey}`,
					// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
				},
			}
		)
			.then((response) => response.json())
			.then((result) => {
				setReasons(result.data)
			})
			.catch((error) => {
				setError(error.message)
				console.log(error)
			})
		setIsMounted(true)
		return () => {
			setError(null)
			setIsMounted(false)
		}
	}, [user.apikey])

	if (!isMounted || !isOpen) return null
	return createPortal(
		<form
			onSubmit={handleSubmit}
			className="fixed z-[11] bg-white rounded-[2px] sm:w-[calc(100%-32px)] md:max-w-[553px] flex flex-col gap-[30px] sm:px-[16px] sm:py-[30px] md:p-[60px] translate-x-[-50%] translate-y-[-50%] top-[50%] left-[50%]"
		>
			<button
				onClick={onClose}
				className="absolute top-[1.5rem] right-[1.5rem] hover:underline text-[#f2994a]"
			>
				Close
			</button>
			{!isSuccess && (
				<>
					<div className="flex-col flex gap-[6px]">
						<div className="text-[20px] sm:mt-[1rem]  font-medium text-center">
							Cancel Medication Order
						</div>
						<div className="text-[14px] my-[5px] text-center leading-[1.3] font-normal">
							Are you sure you want to cancel this order? You can
							reorder this order under your orders page.
						</div>
						<div className="mt-[10px]">
							<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
								What is the reason for canceling this order?
							</div>
							<select
								ref={reasonInputRef}
								name="cancellationReason"
								value={reason}
								onChange={handleReason}
								required
								className="text-[#333333] rounded-[3px] w-full h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
							>
								<option value="" selected>
									Select a reason
								</option>
								{reasons.map((reason) => (
									<option key={reason.id} value={reason.id}>
										{reason.reason}
									</option>
								))}
							</select>
						</div>
					</div>
					{error && (
						<div className="text-[12px] text-[#FF7373] text-center leading-[1]">
							{error}
						</div>
					)}
					<div className="flex flex-col md:flex-row gap-[1rem] justify-center items-center">
						<button
							onClick={handleClose}
							className="text-[#f2994a] sm:order-2 bg-[#f6f7ff] md:w-[150px] w-full  rounded-[3px] flex h-[32px] px-[1rem]"
						>
							<span className="m-auto flex justify-center text-[12px] gap-[0.2rem]">
								No, Keep Order
							</span>
						</button>

						<button
							type="submit"
							className="text-white sm:order-1 bg-[#FF7373] md:w-[150px] w-full  rounded-[3px] flex h-[32px] px-[1rem]"
						>
							{!loading && (
								<span className="m-auto flex justify-center text-[12px] gap-[0.2rem]">
									Confirm Cancelation
								</span>
							)}
							{loading && (
								<div className="grid mx-auto">
									<svg
										className="h-[1.88rem] w-[1.5rem] m-auto"
										version="1.1"
										id="loader-1"
										xmlns="http://www.w3.org/2000/svg"
										x="0px"
										y="0px"
										width="2.50rem"
										height="2.50rem"
										viewBox="0 0 40 40"
										enableBackground="new 0 0 40 40"
									>
										<path
											opacity="0.2"
											d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
										/>
										<path
											d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z"
										>
											<animateTransform
												attributeType="xml"
												attributeName="transform"
												type="rotate"
												from="0 20 20"
												to="360 20 20"
												dur="0.5s"
												repeatCount="indefinite"
											/>
										</path>
									</svg>
								</div>
							)}
						</button>
					</div>
				</>
			)}
			{isSuccess && (
				<>
					<div className="flex-col flex gap-[6px]">
						<div>
							<svg
								className="mx-auto mb-[1rem]"
								width="94"
								height="94"
								viewBox="0 0 94 94"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle cx="47" cy="47" r="35" fill="#FCFFE9" />
								<circle
									cx="47"
									cy="47"
									r="41"
									stroke="#f2994a"
									stroke-opacity="0.1"
									strokeWidth="12"
								/>
								<circle cx="47" cy="47" r="35" fill="#FCFFE9" />
								<circle
									cx="47"
									cy="47"
									r="38"
									stroke="#f2994a"
									stroke-opacity="0.15"
									strokeWidth="6"
								/>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M12 47C12 37.7174 15.6875 28.815 22.2513 22.2513C28.815 15.6875 37.7174 12 47 12C56.2826 12 65.185 15.6875 71.7487 22.2513C78.3125 28.815 82 37.7174 82 47C82 56.2826 78.3125 65.185 71.7487 71.7487C65.185 78.3125 56.2826 82 47 82C37.7174 82 28.815 78.3125 22.2513 71.7487C15.6875 65.185 12 56.2826 12 47ZM45.0027 61.98L65.1533 36.7893L61.5133 33.8773L44.3307 55.3487L32.16 45.208L29.1733 48.792L45.0027 61.9847V61.98Z"
									fill="#f2994a"
								/>
							</svg>
						</div>
						<div className="text-[20px] sm:mt-[1rem]  font-medium text-center">
							Order Cancelled
						</div>
						<div className="text-[14px] my-[5px] text-center leading-[1.3] font-normal">
							Order has been cancelled successfully. Click the
							button below to return to your orders page.
						</div>
					</div>
					<div className="flex flex-col md:flex-row gap-[1rem] justify-center items-center">
						<Link
							to="/orders"
							className="text-white sm:order-2 bg-[#f2994a] md:w-[150px] w-full  rounded-[3px] flex h-[32px] px-[1rem]"
						>
							<span className="m-auto flex justify-center text-[12px] gap-[0.2rem]">
								Continue
							</span>
						</Link>
					</div>
				</>
			)}
		</form>,
		document.getElementById("modal-root")
	)
}

export default CancelOrder
